import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { makeStyles, styled } from "@mui/styles"
import { useTranslation } from "react-i18next"
import { Box, Container, Typography, Grid, Tooltip, tooltipClasses } from "@mui/material"

import GoalAlignmentChart from "../../../components/GoalAlignmentChart"
import GoalChart from "../../../components/GoalChart"
import { getGoalChart } from "../../../actions/mygoal"
import * as Util from "../../../services/global.service"


const useStyles = makeStyles({
  boxActive: {},
});
const styles = {
  container: {
    maxHeight: "100vh",
    border: "1px solid red",
  },
  link: {
    color: "#5DA196",
    cursor: "pointer",
  },
  end: {
    color: "#A3A3A3",
  },
};

const MyGoalAlignmentChart = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const classes = useStyles()
  const { serial } = useParams()

  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])

  useEffect(() => {
    dispatch(getGoalChart(serial)).then((resp) => {
      console.log("goal chart called")
      resp = resp?.data
      if (resp && resp.length > 0) {
        let formatData = resp.map((item) => {
          return {
            id: item.serial,
            pid: item.parent,
            obj: item,
          }
        })
        setData(formatData);
      }
    })
  }, [])

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
      fontSize: '16px'
    }
  }))

  return (
    <>
      <Helmet>
        <title>Goal Alignment Chart | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          pt: 3,
          position: 'relative'
        }}
      >
        <Container maxWidth={false} p={0} sx={{ position: 'relative' }}>
          {/* <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => navigate('/kpi/home', { replace: false })}>
                {t('label.home')}
              </span> / &nbsp;
              <span style={styles.link} onClick={() => navigate(`/kpi/mygoal`, { replace: false })}>
                {t('mygoal.label.title')}
              </span> / &nbsp;
              <span style={styles.end} >
                {t('mygoal.label.goalDetail')}
              </span>
            </Typography>
          </Grid> */}
          <Grid container pt={2} mb={1}>
            <Grid item>
              <Typography color="#404349" fontSize={36} lineHeight="39.6px" fontWeight="600">
                {t('label.goalChart')}
              </Typography>
            </Grid>
          </Grid>
          {/* <GoalAlignmentChart
            nodes={data}
          /> */}
          <GoalChart nodes={data} />
        </Container>
      </Box>
    </>
  );
};
export default MyGoalAlignmentChart;
